import { useState, useEffect } from "react";

export const useAddTask = (open: boolean, item: any, onConfirm: any) => {
    const [form, setForm] = useState({});
    const [error, setError] = useState("");
    const [isValid, setIsValid] = useState(true);

    const addDecription = async (d) => {
        let f = form;
        f["description"] = d["content"];
        setForm(JSON.parse(JSON.stringify(f)));

        if (f["edate"] && f["description"]) {
            onConfirm({ data: f });
            setError("");
        } else {
            setError("Completa los campos para generar el registro.");
        }
    };

    const onHandleChange = (key, e) => {
        let f = form;
        key === "edate" ? (f[key] = e.target.value) : (f[key] = e.target.value);

        setForm(JSON.parse(JSON.stringify(f)));
        validateForm(JSON.parse(JSON.stringify(f)));
    };

    const validateForm = (f) => {
        if (f["edate"] && f["description"]) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    };

    useEffect(() => {
        if (open && item) {
            const session = JSON.parse(localStorage.getItem("session"));
            let resetForm = {};

            if (item["edit"]) {
                resetForm = {
                    lead_uuid: item["lead_uuid"],
                    uuid: item["uuid"],
                    description: item["description"],
                    edate: item["edate"].slice(0, 16),
                };
                if(item["comments"]){
                    resetForm["comments"] = item["comments"];
                }
            } else {
                resetForm = {
                    lead_uuid: item["uuid"],
                    app_uuid: item["app_uuid"],
                    type: item["sectionName"],
                    description: "",
                    comments: [],
                    archived: false,
                    is_completed: false,
                    created_by: {
                        email: session.email,
                        uuid: session.uuid,
                        name: session.name,
                    },
                };
            }

            setForm(resetForm);
            setError("");
        } else {
            setForm({});
            setError("");
            setIsValid(true);
        }
    }, [open, item]);

    return { form, error, isValid, addDecription, onHandleChange };
};
